import {CLEAR_ROOM, SET_IN_ROOM_FIELDS, SET_ROOM, SET_TYPE_LIST} from "./constans";

let initialState = {};

const objectRoomEditReducers = (state = initialState, action) => {

    switch (action.type) {
        case SET_ROOM:
            return {
                ...state,
                ...action.payload
            }
        case CLEAR_ROOM:
            let newState = {...state}
            Object.getOwnPropertyNames(newState).forEach(function (prop) {
                delete newState[prop];
            });

            return {...newState}
        case SET_TYPE_LIST:
            return {
                ...state,
                typesList: action.payload
            }
        case SET_IN_ROOM_FIELDS:
            return {
                ...state,
                inRoom: action.payload
            }
        default:
            return state;
    }
};


export default objectRoomEditReducers;